import React from 'react';
import Unauthorized from '../unauthorized/Unauthorized';
import { useEvents } from '../../hooks/useEvents';
import { getEnvironmentVariable } from '../../utils';

type UnauthorizedBoundaryProps = {
    children: React.ReactNode;
    onLogin?: () => void;
};

const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');
const LOGIN_URL = `${platformURL}/login`;

const UnauthorizedBoundary: React.FC<UnauthorizedBoundaryProps> = ({ children, onLogin }) => {
    const { subscribe } = useEvents();
    const [ unauthorized, setUnauthorized ] = React.useState(false);

    React.useEffect(() => {
        return subscribe('http-401', (data) => {
            if (data.code === 401) {
                // directly go to login page
                window.location.href = `${LOGIN_URL}?callback=${window.location.href}`;
                return;
            }

            setUnauthorized(true);
        });
    }, [ subscribe ]);

    if (unauthorized) {
        return <Unauthorized onLogin={onLogin}/>;
    }

    return <>{children}</>;
};

export default UnauthorizedBoundary;
